import ContactInfoContainer from './contact_info_container';

const ContactInfo = ContactInfoContainer;
export default ContactInfo;
